<template>
    <a-modal title="新增邮寄" :width="1300" :open="true" :maskClosable="false" :confirmLoading="state.confirmLoading"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="formRef" :model="formState" :rules="rules" v-bind="formLayout">
                <a-form-item label="邮寄公司名称"> {{ props.tableColumnsData.entityNameToRegister?.full_name }}<span
                        v-if="state.storeShelfCode">【{{ state.storeShelfCode
                        }}】</span></a-form-item>

                <a-form-item label="有多家公司一起邮寄" v-if="state.customer_list?.length > 0">
                    <a-checkbox-group v-model:value="formState.customer_ids" @change="calcRemark">
                        <a-checkbox v-for="(item, index) in state.customer_list" :key="index" :value="item.id">
                            {{ item.full_name }} <span v-if="item.storeShelfCode">【{{ item.storeShelfCode
                                }}】</span><a-tag color="green">{{ item.business_type_name }}：{{
                                    item.after_status_name }}</a-tag></a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="其他续费联系人">
                    <div class="merge-select-actions">
                        <a-button type="dashed" @click="openOtherModal">
                            <PlusOutlined /> 其他（搜索跨续费联系人订单）
                        </a-button>
                        <span class="merge-tip" v-if="state.otherMailList.length > 0">
                            已额外加入 <b class="cross-num">{{ state.otherMailList.length }}</b> 个跨联系人订单
                        </span>
                    </div>
                    <div>
                        <a-checkbox-group v-model:value="formState.customer_other_ids" @change="calcRemark">
                            <a-checkbox v-for="(item, index) in state.otherMailList" :key="index" :value="item.id">
                                {{ item.full_name }} <span v-if="item.storeShelfCode">【{{ item.storeShelfCode
                                    }}】</span><a-tag color="green">{{ item.business_type_name }}：{{
                                        item.after_status_name }}</a-tag></a-checkbox>
                        </a-checkbox-group>
                    </div>
                </a-form-item>
                <!-- 邮寄物品预览 -->
                <a-form-item label="邮寄物品预览" v-if="previewText">
                    <div class="mail-preview">{{ previewText }}</div>
                </a-form-item>

                <a-form-item name="mailing_kdgs" label="快递公司" required>
                    <a-radio-group v-model:value="formState.mailing_kdgs" button-style="solid">
                        <a-radio-button :value="1"><img :src="formState.mailing_kdgs == 2 ? jdIconBlack : jdIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 京东快递 </a-radio-button>
                        <a-radio-button :value="2"><img :src="formState.mailing_kdgs == 1 ? sfIconBlack : sfIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 顺丰快递 </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formState.pay_type" :options="plainOptions" />
                </a-form-item>
                <a-form-item label="平台余额" v-if="formState.pay_type == 1">
                    ￥{{ state.moeny }}元（可用于支付快递费）<a-button type="primary" @click="payLogistics" danger
                        size="small">充值邮费</a-button>
                </a-form-item>
                <a-form-item label="特别备注">
                    <a-input style="width: 400px" v-model:value="formState.remark" type="textarea"
                        @input="calcRemark"></a-input>
                </a-form-item>
                <a-form-item label="邮寄方式">
                    <a-radio-group v-model:value="formState.is_timing">
                        <a-radio :value="1"> 立马邮寄 </a-radio>
                        <a-radio :value="2"> 定时邮寄 </a-radio>
                        <a-radio :value="3"> 触发式自动邮寄 </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="触发条件" v-if="formState.is_timing == 3" required>
                    <a-select allow-clear v-model:value="formState.condition" placeholder="请选择触发条件"
                        style="width: 400px">
                        <a-select-option :value="1">当外勤第一次已拿章时，自动触发邮寄</a-select-option>
                        <a-select-option :value="2">当外勤第一次上传营业执照时，自动触发邮寄</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="上门取货时间" v-if="formState.is_timing == 2" required>
                    <a-date-picker v-model:value="formState.timing_time" :format="format" show-time />
                </a-form-item>
                <div class="d-flex">
                    <div class="flex-1">
                        <a-form-item label="寄件人姓名" name="send_name" required has-feedback
                            :validate-status="checkdatastate.send_name">
                            <a-input placeholder="请输入寄件人姓名" v-model:value="formState.send_name" @change="
                                () => {
                                    checkdatastate.send_name = formState.send_name ? 'success' : 'error'
                                }
                            "></a-input>
                        </a-form-item>
                        <a-form-item label="寄件人电话" name="send_tel" required has-feedback
                            :validate-status="checkdatastate.send_tel">
                            <a-row>
                                <a-col :span="17">
                                    <a-input placeholder="请输入寄件人电话" v-model:value="formState.send_tel" @change="
                                        (v) => {
                                            phoneChange(formState.send_tel, 'send_tel')
                                        }
                                    "></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="formState.emailLoading_send" type="primary"
                                        @click="emailChange(1)" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="寄件人省市区" name="send_paua" has-feedback
                            :validate-status="checkdatastate.send_paua">
                            <AddressCascader width="100%" v-model:value="formState.send_paua"
                                @change="senderPauaChange">
                            </AddressCascader>
                        </a-form-item>
                        <a-form-item label="寄件人详细地址" name="send_address" required has-feedback
                            :validate-status="checkdatastate.send_address">
                            <a-textarea placeholder="请选择寄件人详细地址" v-model:value="formState.send_address"
                                @change="senderAddressChange"></a-textarea>
                            <a-button type="primary" @click="parseReceiveAddress"
                                :loading="state.parseReceiveAddressLoading" style="margin-top:5px"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                    <div class="flex-1">
                        <a-form-item label="收件人姓名" name="receive_name" required has-feedback
                            :validate-status="checkdatastate.receive_name">
                            <a-input v-model:value="formState.receive_name" placeholder="请输入收件人姓名" @change="
                                () => {
                                    checkdatastate.receive_name = formState.receive_name ? 'success' : 'error'
                                }
                            "></a-input>
                        </a-form-item>
                        <a-form-item label="收件人电话" name="receive_tel" required has-feedback
                            :validate-status="checkdatastate.receive_tel">
                            <a-row>
                                <a-col :span="17">
                                    <a-input v-model:value="formState.receive_tel" @change="
                                        (v) => {
                                            phoneChange(formState.receive_tel, 'receive_tel')
                                        }
                                    " placeholder="请输入收件人电话"></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="formState.emailLoading_receive" type="primary"
                                        @click="emailChange(2)" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="收件人省市区" name="receive_paua" has-feedback
                            :validate-status="checkdatastate.receive_paua">
                            <AddressCascader width="100%" v-model:value="formState.receive_paua"
                                @change="recipientChange">
                            </AddressCascader>
                        </a-form-item>
                        <a-form-item label="收件人详细地址" name="receive_address" required has-feedback
                            :validate-status="checkdatastate.receive_address">
                            <a-textarea placeholder="请选择收件人详细地址" v-model:value="formState.receive_address"
                                @change="receiveAddressChange"></a-textarea>
                            <a-button type="primary" @click="parseReceiveAddress2"
                                :loading="state.parseReceiveAddressLoading2" style="margin-top:5px"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </a-spin>
        <!-- 提示 -->
        <a-modal v-model:open="state.showtip" title="提示" @ok="handleTipOk">
            <ExclamationCircleOutlined style="color: red;" />&nbsp;&nbsp;&nbsp;{{ state.tipinfo }}
        </a-modal>
        <!-- 支付邮费 -->
        <PlatformBalanceCharge v-if="state.payLogisticsVisible" @cancel="handleCancel" @ok="handleOk"
            :logisticsCustomerId="props.tableColumnsData.id ?? ''" :logisticsAreaIds="formState.receive_paua">
        </PlatformBalanceCharge>
        <!-- 选择其他续费联系人的单 -->
        <SFMailSelectOther v-if="state.otherMailVisible" :customer-other-ids="formState.customer_other_ids"
            :customerId="props.tableColumnsData.id" @cancel="handleCancel" @ok="handleOtherMailOk">
        </SFMailSelectOther>
    </a-modal>
</template>

<script lang="ts" setup>
import { AddressCascader } from '@/components'
import cloneDeep from 'lodash.clonedeep'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
import { ref, reactive, onMounted, h, computed } from 'vue'
import { message } from 'ant-design-vue'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import jdIconBlack from '@/assets/icons/jd-icon-black.png'
import jdIconWhite from '@/assets/icons/jd-icon-white.png'
import { parseAddress } from '@/utils/util'
import PlatformBalanceCharge from './../../financialManagement/components/PlatformBalanceCharge.vue'
import SFMailSelectOther from './SFMailSelectOther.vue'
import { ScanOutlined, CloudDownloadOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => null
    },
    copyNumber: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['cancel', 'ok'])
const format = 'YYYY-MM-DD HH:mm:ss'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
    }
}
onMounted(() => {
    queryCustomerSf()
})
const plainOptions = [
    { label: '寄付(顺丰速运小程序->查快递->待支付付款)', value: 1 },
    { label: '到付', value: 2 }
]
interface state {
    customer_list: any[]
    storeShelfCode: number
    remark: string
    loading: boolean
    confirmLoading: boolean
    oldshengshiqu_send: string
    oldshengshiqu_receive: string
    parseReceiveAddressLoading: boolean
    parseReceiveAddressLoading2: boolean
    showtip: boolean
    tipinfo: string
    payLogisticsVisible: boolean
    otherMailVisible: boolean
    otherMailList: any[] //其他单选项列表
    moeny: number
}
const checkdatastate = reactive<any>({})
const state = reactive<state>({
    customer_list: [],
    storeShelfCode: 0,
    remark: '',
    loading: false,
    confirmLoading: false,
    oldshengshiqu_send: '',
    oldshengshiqu_receive: '',
    parseReceiveAddressLoading: false,
    parseReceiveAddressLoading2: false,
    showtip: false,
    tipinfo: '',
    payLogisticsVisible: false,
    otherMailVisible: false,
    otherMailList: [],
    moeny: 0
})
const formRef = ref()
interface from {
    mailing_kdgs: number
    pay_type: number
    is_timing: number
    remark: string
    remarkShelfCode: any[]
    timing_time: any
    customer_ids: any[]
    customer_other_ids: any[]
    receive_address: string
    receive_paua: string
    receive_tel: string
    receive_name: string
    send_address: string
    send_paua: string
    send_tel: string
    send_name: string
    emailLoading_send: boolean
    emailLoading_receive: boolean
    xftel: string,
    condition: number | null
}
const formState = reactive<from>({
    mailing_kdgs: 1,
    pay_type: 1,
    is_timing: 1,
    remark: '',
    remarkShelfCode: [],
    customer_ids: [],
    customer_other_ids: [],
    timing_time: null,
    receive_address: '',
    receive_paua: '',
    receive_tel: '',
    receive_name: '',
    send_address: '',
    send_paua: '',
    send_tel: '',
    send_name: '',
    emailLoading_send: false,
    emailLoading_receive: false,
    xftel: '',
    condition: null
})
const rules = reactive({
    send_paua: [{ required: true, message: '请选择寄件人地址' }],
    receive_paua: [{ required: true, message: '请选择收件人地址' }]
})

// 邮寄物品预览：所有公司全称 + 特别备注 + 货架号列表
// 例子：【A公司全称】【B公司全称】...营业执照【3、33、5、19、18、2、40、43、2】
const previewText = computed(() => {
    const companyNames: string[] = []
    const codes: number[] = []

    // 1. 当前主公司（A公司）
    if (props.tableColumnsData.entityNameToRegister?.full_name) {
        companyNames.push(props.tableColumnsData.entityNameToRegister.full_name)
    }
    if (state.storeShelfCode) {
        codes.push(state.storeShelfCode)
    }

    // 2. 勾选的其它公司（C、D 公司）
    state.customer_list.forEach((item) => {
        if (formState.customer_ids.indexOf(item.id) !== -1) {
            if (item.full_name) {
                companyNames.push(item.full_name)
            }
            if (item.storeShelfCode) {
                codes.push(item.storeShelfCode)
            }
        }
    })
    // 3. ★ 勾选的跨续费联系人订单（otherMailList ∩ customer_other_ids）
    state.otherMailList.forEach((item) => {
        if (formState.customer_other_ids.indexOf(item.id) !== -1) {
            if (item.full_name) companyNames.push(item.full_name)
            if (item.storeShelfCode) codes.push(item.storeShelfCode)
        }
    })

    // 没公司又没备注，就不显示
    const remark = (formState.remark || '').trim()
    if (companyNames.length === 0 && !remark) {
        return ''
    }

    // 3. 公司全称连排
    const companyStr = companyNames.map((name) => `【${name}】`).join('')

    // 4. 特别备注
    const remarkStr = remark

    // 5. 货架号列表
    const codeStr = codes.length > 0 ? `【${codes.join('、')}】` : ''

    return companyStr + remarkStr + codeStr
})

// 获取邮寄信息
const emailChange = (type) => {
    if (!formState.xftel && !formState.send_tel) {
        message.warn('请填写续费联系人手机号码或寄件人手机号码后再获取邮寄信息')
        return
    }

    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: formState.receive_tel ?? formState.xftel
        }
    }
    if (type == 1) {
        requeryParam['data']['customer_tel'] = formState.send_tel
        formState.emailLoading_send = true
    } else {
        formState.emailLoading_receive = true
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                if (type == 2) {
                    formState.receive_name = res.data.list[0].name
                    formState.receive_tel = res.data.list[0].tel
                    formState.receive_address = res.data.list[0].address
                    formState.receive_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                } else {
                    formState.send_name = res.data.list[0].name
                    formState.send_tel = res.data.list[0].tel
                    formState.send_address = res.data.list[0].address
                    formState.send_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                }
            }
            message.success(res.msg)
            formState.emailLoading_send = false
            formState.emailLoading_receive = false
        })
        .catch((res) => {
            if (res) {
                formState.emailLoading_send = false
                formState.emailLoading_receive = false
                if (res.msg) {
                    message.warning(res.msg)
                    return
                }
            }
        })
    //   }
}
const queryCustomerSf = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/customerSf?customer_id=${props.tableColumnsData.id}&copyNumber=${props.copyNumber}`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            formState.mailing_kdgs = res.data.mailing_kdgs
            formState.pay_type = res.data.payment_type
            state.customer_list = res.data.customer_list
            state.storeShelfCode = res.data.storeShelfCode
            state.remark = res.data.remark
            state.moeny = res.data.youfeiyue
            formState.remark = res.data.remark
            calcRemark()
            let send: any = res.data.send
            formState.send_name = send.name
            formState.send_tel = send.tel
            formState.send_paua = `${send.provinceid},${send.cityid},${send.areaid}`
            formState.send_address = send.address
            let receive: any = res.data.receive
            formState.receive_name = receive.name
            formState.receive_tel = receive.tel
            if (receive?.provinceid && receive.cityid && receive.areaid) {
                formState.receive_paua = `${receive.provinceid},${receive.cityid},${receive.areaid}`
            }
            formState.receive_address = receive.address
            formState.xftel = res.data.xftel
            state.loading = false
            checkdatastate.send_name = formState.send_name ? 'success' : 'error'
            phoneChange(formState.send_tel, 'send_tel')
            checkdatastate.send_paua = formState.send_paua ? 'success' : 'error'
            checkdatastate.send_address = formState.send_address ? 'success' : 'error'
            //如果有提示
            if (res.data.tip) {
                state.showtip = true
                state.tipinfo = res.data.tip
            }
        })
        .catch((res) => {
            message.error(res?.mas ? res.msg : '自动获取失败请手动输出信息')
            state.loading = false
        })
}

const phoneChange = (v, type) => {
    let str = v.replaceAll(/\D/g, '')
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}

// 注意：这里不再用 state.remark 覆盖 formState.remark
// formState.remark 由用户输入控制，previewText 会自动跟着更新
const calcRemark = () => {
    let remarkShelfCode: any[] = []
    remarkShelfCode.push({ 'id': props.tableColumnsData.id, 'code': state.storeShelfCode })
    state.customer_list.forEach((item) => {
        //判断item.id 是否在 formState.customer_ids 中
        if (formState.customer_ids.indexOf(item.id) !== -1) {
            remarkShelfCode.push({ 'id': item.id, 'code': item.storeShelfCode })
        }
    })
    state.otherMailList.forEach((item) => {
        if (formState.customer_other_ids.indexOf(item.id) !== -1) {
            remarkShelfCode.push({ id: item.id, code: item.storeShelfCode })
        }
    })
    formState.remarkShelfCode = remarkShelfCode
}
const senderPauaChange = (e, val) => {
    let address = ''
    if (val) {
        checkdatastate.send_paua = 'success'
        //开始处理addresss
        address = `${val[0].name}${val[1].name}${val[2].name}`
        if (state.oldshengshiqu_send && formState.send_address) {
            formState.send_address = formState.send_address.replace(state.oldshengshiqu_send, '')
        }
        state.oldshengshiqu_send = address //把当前的选中的省市区赋值给一个变量
        formState.send_address = formState.send_address ? address + formState.send_address : address
        checkdatastate.send_address = formState.send_address == address ? 'error' : 'success'
    } else {
        checkdatastate.send_paua = 'error'
    }
}
const recipientChange = (e, val) => {
    let address = ''
    if (val) {
        checkdatastate.receive_paua = 'success'
        //开始处理addresss
        address = `${val[0].name}${val[1].name}${val[2].name}`
        if (state.oldshengshiqu_receive && formState.receive_address) {
            formState.receive_address = formState.receive_address.replace(state.oldshengshiqu_receive, '')
        }
        state.oldshengshiqu_receive = address //把当前的选中的省市区赋值给一个变量
        formState.receive_address = formState.receive_address ? address + formState.receive_address : address
        checkdatastate.receive_address = formState.receive_address == address ? 'error' : 'success'
    } else {
        checkdatastate.receive_paua = 'error'
    }
}
const onFormSubmit = () => {
    if (formState.is_timing == 3 && !formState.condition) {
        message.error('请选择触发条件！')
        return
    }
    formRef.value.validate().then(() => {
        let data: any = cloneDeep(formState)
        let param: any = {}
        const allIds = new Set<number>([
            ...data.customer_ids,
            ...data.customer_other_ids,
            props.tableColumnsData.id
        ])
        param.customer_ids = [...allIds]
        param.remarkShelfCode = data.remarkShelfCode
        param.send = {
            provinceid: parseInt(data.send_paua.split(',')[0]),
            cityid: parseInt(data.send_paua.split(',')[1]),
            areaid: parseInt(data.send_paua.split(',')[2]),
            address: data.send_address,
            tel: data.send_tel,
            name: data.send_name
        }
        param.receive = {
            provinceid: parseInt(data.receive_paua.split(',')[0]),
            cityid: parseInt(data.receive_paua.split(',')[1]),
            areaid: parseInt(data.receive_paua.split(',')[2]),
            address: data.receive_address,
            tel: data.receive_tel,
            name: data.receive_name
        }
        param.timing_time = dayjs(data.timing_time, format)
        param.condition = data.condition
        param.remark = data.remark
        param.pay_type = data.pay_type
        param.mailing_kdgs = data.mailing_kdgs
        param.is_timing = data.is_timing
        param.full_name = props.tableColumnsData.entityNameToRegister?.full_name
        state.confirmLoading = true
        let requestParam = {
            url: `/admin/v1/customerSfPush`,
            method: 'post',
            data: param
        }
        baseService(requestParam)
            .then((res: any) => {
                state.confirmLoading = false
                message.success(res?.msg ? res.msg : '发送成功', 8)
                emit('cancel')
            })
            .catch((res) => {
                state.confirmLoading = false
                message.error(res?.msg ? res.msg : '操作失败请联系管理员')
            })
    })
}
//寄件人详细地址改变
const senderAddressChange = () => {
    if (formState.send_address) {
        checkdatastate.send_address = state.oldshengshiqu_send == formState.send_address ? 'error' : 'success'
    } else {
        checkdatastate.send_address = 'error'
    }
}
const receiveAddressChange = () => {
    if (formState.receive_address) {
        checkdatastate.receive_address = state.oldshengshiqu_receive == formState.receive_address ? 'error' : 'success'
    } else {
        checkdatastate.receive_address = 'error'
    }
}
//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.send_address).then((res: any) => {
        if (res.name) {
            formState.send_name = res.name
        }
        if (res.phone) {
            formState.send_tel = res.phone
        }
        if (res.area_ids) {
            formState.send_paua = res.area_ids
        }
        if (res.address) {
            formState.send_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
const parseReceiveAddress2 = () => {
    state.parseReceiveAddressLoading2 = true
    parseAddress(formState.receive_address).then((res: any) => {
        if (res.name) {
            formState.receive_name = res.name
        }
        if (res.phone) {
            formState.receive_tel = res.phone
        }
        if (res.area_ids) {
            formState.receive_paua = res.area_ids
        }
        if (res.address) {
            formState.receive_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading2 = false
    })
}
const handleTipOk = () => {
    state.showtip = false
}
const payLogistics = (record) => {
    state.payLogisticsVisible = true
}
const openOtherModal = () => {
    state.otherMailVisible = true
}
const handleCancel = () => {
    state.payLogisticsVisible = false
    state.otherMailVisible = false
}
const handleOk = () => {
    state.payLogisticsVisible = false
}
const handleOtherMailOk = (selectedRows) => {
    const existIds = new Set(state.otherMailList.map(i => i.id))
    const newRows = selectedRows.filter(r => !existIds.has(r.id))
    state.otherMailList = [...state.otherMailList, ...newRows]

    // 默认勾选新加入的
    const checked = new Set(formState.customer_other_ids)
    selectedRows.forEach(r => checked.add(r.id))
    formState.customer_other_ids = [...checked]

    state.otherMailVisible = false
    calcRemark()
}
</script>

<style lang="less" scoped>
.mail-preview {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    padding: 8px 12px;
    color: #389e0d;
    font-size: 14px;
    word-break: break-all;
    line-height: 1.8;
}

/* ===== 合并邮寄 Select ===== */
.merge-select-box {
    width: 100%;
}

.merge-select-actions {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.merge-tip {
    font-size: 13px;
    color: #595959;

    .cross-num {
        color: #fa541c;
    }
}

.cross-contact-tip {
    margin-top: 4px;
    color: #fa8c16;
    font-size: 12px;
}

/* ===== 其他弹窗 ===== */
.other-search-bar {
    margin-bottom: 12px;
}
</style>
